import * as React from "react"
import { Head, usePage } from "@inertiajs/react"
import { Card } from "@ui/Card"
import type { SharedPageProps } from "@lib/inertia-types"

function GoogleGlyph() {
  return (
    <svg className="size-4" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M23.52 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.09 3.58-5.17 3.58-8.81z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.88-3.01c-1.07.72-2.45 1.15-4.06 1.15-3.13 0-5.78-2.11-6.72-4.95H1.27v3.11A12 12 0 0 0 12 24z" />
      <path fill="#FBBC05" d="M5.28 14.28a7.2 7.2 0 0 1 0-4.56V6.61H1.27a12 12 0 0 0 0 10.78l4.01-3.11z" />
      <path fill="#EA4335" d="M12 4.77c1.76 0 3.35.61 4.59 1.8l3.44-3.44A11.97 11.97 0 0 0 12 0 12 12 0 0 0 1.27 6.61l4.01 3.11C6.22 6.88 8.87 4.77 12 4.77z" />
    </svg>
  )
}

export default function InvitationShow({
  organization_name,
  email,
}: {
  organization_name: string
  email: string
}) {
  const { props } = usePage<SharedPageProps>()

  return (
    <>
      <Head title={`Join ${organization_name} · Fetch`} />
      <div className="grid min-h-screen place-items-center bg-cloverhound-gray-50 p-4 dark:bg-cloverhound-gray-950">
        <div className="w-full max-w-sm">
          <div className="mb-6 flex flex-col items-center gap-2 text-center">
            <div aria-hidden="true" className="flex size-10 items-center justify-center rounded-lg bg-cloverhound-indigo-600 text-large font-bold text-white">
              F
            </div>
            <h1 className="text-large font-semibold text-cloverhound-gray-900 dark:text-cloverhound-gray-50">
              Join {organization_name}
            </h1>
            <p className="text-small text-cloverhound-gray-700 dark:text-cloverhound-gray-400">
              You've been invited to <strong>{organization_name}</strong> on Fetch.
            </p>
          </div>

          <Card padding="lg">
            <p className="mb-4 text-mini text-cloverhound-gray-600">
              Sign in with the Google account for <strong>{email}</strong> to accept.
            </p>
            <form method="post" action="/auth/google_oauth2">
              <input type="hidden" name="authenticity_token" value={props.csrf_token ?? ""} />
              <button
                type="submit"
                className="flex h-9 w-full items-center justify-center gap-2.5 rounded-md border border-cloverhound-gray-250 bg-white text-small font-medium text-cloverhound-gray-900 shadow-xs transition-colors duration-quick ease-out-quad hover:bg-cloverhound-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cloverhound-indigo-500 dark:border-cloverhound-gray-800 dark:bg-cloverhound-gray-900 dark:text-cloverhound-gray-50 dark:hover:bg-cloverhound-gray-850"
              >
                <GoogleGlyph />
                Continue with Google
              </button>
            </form>
          </Card>
        </div>
      </div>
    </>
  )
}
